import { configureStore } from "@reduxjs/toolkit";
import commonSlice from "./reducers/commonSlice";
import mediaModalSlice from "./reducers/mediaModalSlice";

export const store = configureStore({
    reducer: {
        common: commonSlice,
        mediamodal: mediaModalSlice
    }
});